(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
		document.addEventListener('DOMContentLoaded', function() {
			const variantLinks = document.querySelectorAll('[data-variant-id]');
			const variantInput = document.getElementById('product-variant-id');
			
			if (variantLinks.length && variantInput) {
				variantLinks.forEach(function(link) {
					link.addEventListener('click', function(e) {
						e.preventDefault();
						const variantId = this.getAttribute('data-variant-id');
						if (variantId) {
							variantInput.value = variantId;
						}
					});
				});
			}
		});
		
  } catch(e) { console.error(e); }
})();
})();
